import styles from "./TaskCardHeader.module.css"
import { IconButton } from "../../common/button/IconButton"
import { IconName } from "../../icons/Icon"
import {
  ContextMenu,
  type ContextMenuItemProps,
  type ContextMenuPlacement,
} from "../../common/contextMenu/ContextMenu"

export default function TaskCardHeader({
  title,
  onClose,
  contextMenuOpen,
  onContextMenuClose,
  contextMenuItems,
  onContextMenuTriggerClick,
  contextMenuPlacement = "bottom-left",
  showContextMenuTrigger = true,
}: {
  title: string
  onClose: () => void
  contextMenuOpen?: boolean
  onContextMenuClose?: () => void
  contextMenuItems?: ContextMenuItemProps[]
  onContextMenuTriggerClick?: () => void
  /** Where the context menu opens relative to the trigger. Default: "bottom-left". */
  contextMenuPlacement?: ContextMenuPlacement
  /** When false, the three-dots context menu trigger is not shown. Default: true. */
  showContextMenuTrigger?: boolean
}) {
  const hasContextMenu =
    showContextMenuTrigger &&
    contextMenuItems != null &&
    onContextMenuClose != null &&
    onContextMenuTriggerClick != null

  const contextMenuTrigger = (
    <IconButton
      icon={IconName.DotGrid1x3Vertical}
      onClick={(e) => {
        e.stopPropagation()
        onContextMenuTriggerClick?.()
      }}
    />
  )

  return (
    <div className={styles.container}>
      <span className={styles.title}>{title}</span>
      <div className={styles.buttonContainer}>
        {hasContextMenu ? (
          <ContextMenu
            isOpen={contextMenuOpen ?? false}
            onClose={onContextMenuClose}
            items={contextMenuItems}
            placement={contextMenuPlacement}
          >
            {contextMenuTrigger}
          </ContextMenu>
        ) : showContextMenuTrigger ? (
          contextMenuTrigger
        ) : null}
        <IconButton
          icon={IconName.CrossLarge}
          onClick={(e) => {
            e.stopPropagation()
            onClose()
          }}
        />
      </div>
    </div>
  )
}
